import AddReception from './AddReception.jsx';
import ListInfoDocumentDialog from './ListInfoDocumentDialog.jsx';
import SearchFullNamePopup from './SearchFullNamePopup.jsx';
import ListGroupTypeReception from './ListGroupTypeReception.jsx';
import ThongTinDon from './ThongTinDon.jsx';
import ThongTinNguoiDungDon from './ThongTinNguoiDungDon.jsx';
export {
  AddReception,
  ListInfoDocumentDialog,
  SearchFullNamePopup,
  ListGroupTypeReception,
  ThongTinDon,
  ThongTinNguoiDungDon
};



// WEBPACK FOOTER //
// ./src/components/modules/reception/add-reception/index.js